Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _react = require("react");
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var _Header = require("../Header");
var useStyles = exports.useStyles = function useStyles() {
  var _useContext = (0, _react.useContext)(_Header.HeaderContext),
    textColor = _useContext.textColor;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors,
    bp = _STYLES$useStyles.bp,
    spacing = _STYLES$useStyles.spacing,
    fontBold = _STYLES$useStyles.fontBold,
    fontSemiBold = _STYLES$useStyles.fontSemiBold;
  var container = {
    alignItems: 'center'
  };
  var shortTermTarget = {
    alignItems: 'flex-end'
  };
  if (bp.not([bp.mobile_xs, bp.mobile_s])) {
    shortTermTarget.flexDirection = 'row';
  }
  var shortTermTargetItem = {
    width: (0, _styles.getREM)(8.125)
  };
  var shortTermTargetItemTitle = Object.assign({}, fontBold, {
    textAlign: 'center',
    color: textColor || colors.alternative,
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s
  });
  var shortTermTargetItemTitleAlt = {
    color: textColor || colors.positive
  };
  var shortTermTargetItemText = Object.assign({}, fontSemiBold, {
    textAlign: 'center',
    color: textColor || colors.brand,
    fontSize: _styles.STYLES.fontSize.xs,
    lineHeight: _styles.STYLES.lineHeight.xs
  });
  var shortTermValueTargetItemGroup = {
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  };
  var shortTermTargetItemIcon = {
    marginRight: spacing.xxs,
    width: (0, _styles.getREM)(1),
    height: (0, _styles.getREM)(1)
  };
  var longTermTarget = {
    backgroundColor: colors.focus,
    borderRadius: (0, _styles.getREM)(1.25),
    paddingTop: spacing.xs,
    paddingBottom: spacing.xs,
    paddingLeft: spacing.l,
    paddingRight: spacing.l,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: spacing.l,
    minHeight: (0, _styles.getREM)(2.5)
  };
  var longTermTargetText = Object.assign({}, fontBold, {
    textAlign: 'center',
    color: colors.brand,
    fontSize: _styles.STYLES.fontSize.s,
    lineHeight: _styles.STYLES.lineHeight.s
  });
  var styles = _reactNative.StyleSheet.create({
    container: container,
    shortTermTarget: shortTermTarget,
    shortTermTargetItem: shortTermTargetItem,
    shortTermTargetItemTitle: shortTermTargetItemTitle,
    shortTermTargetItemTitleAlt: shortTermTargetItemTitleAlt,
    shortTermTargetItemText: shortTermTargetItemText,
    shortTermValueTargetItemGroup: shortTermValueTargetItemGroup,
    shortTermTargetItemIcon: shortTermTargetItemIcon,
    longTermTarget: longTermTarget,
    longTermTargetText: longTermTargetText
  });
  return {
    styles: styles
  };
};